import React from "react";
import { Link } from "react-router-dom";
import Layout from "../layouts";
import imgAlumni from "../images/alumni.png";
import imgTeacher from "../images/teacher.png";

export default function MembershipType() {
  return (
    <Layout>
      <div className="container mx-auto">
        <div className="lg:py-5 lg:px-0 py-4 px-4">
          <h1 className="font-bold text-lg mb-4">
            Please select membership type:
          </h1>
          {/* <div className="flex flex-col space-y-4 items-center justify-center">
            <Link
              to="/alumni"
              className="border border-orange-600 rounded-full px-8 py-4 text-center inline-block bg-orange-600 text-white hover:bg-orange-700 transition duration-200 focus:outline-none text-lg"
            >
              EdUHK Alumni
              <svg
                className="w-6 h-6 inline-block ml-1"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                ></path>
              </svg>
            </Link>
            <Link
              to="/teacher"
              className="border border-red-600 rounded-full px-8 py-4 text-center inline-block bg-red-600 text-white hover:bg-red-700 transition duration-200 focus:outline-none text-lg"
            >
              School Teacher
              <svg
                className="w-6 h-6 inline-block ml-1"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                ></path>
              </svg>
            </Link>
            <Link
              to="/individual"
              className="border border-blue-600 rounded-full px-8 py-4 text-center inline-block bg-blue-600 text-white hover:bg-blue-700 transition duration-200 focus:outline-none text-lg"
            >
              Individual
              <svg
                className="w-6 h-6 inline-block ml-1"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                ></path>
              </svg>
            </Link>
          </div> */}
          {/* <div className="max-w-3xl mx-auto mt-8">
            <div className="grid grid-cols-2 gap-8">
              <div>
                <img src={imgAlumni} className="h-64 object-contain" alt="" />
                <div className="mt-4 text-center">
                  <Link
                    to="/alumni"
                    className="border border-orange-600 rounded-full px-8 py-4 text-center inline-block bg-orange-600 text-white hover:bg-orange-700 transition duration-200 focus:outline-none text-lg"
                  >
                    EdUHK Alumni
                    <svg
                      className="w-6 h-6 inline-block ml-1"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                      ></path>
                    </svg>
                  </Link>
                </div>
              </div>
              <div>
                <img src={imgTeacher} className="h-64 object-contain" alt="" />
                <div className="mt-4 text-center">
                  <Link
                    to="/teacher"
                    className="border border-red-600 rounded-full px-8 py-4 text-center inline-block bg-red-600 text-white hover:bg-red-700 transition duration-200 focus:outline-none text-lg"
                  >
                    School Teacher
                    <svg
                      className="w-6 h-6 inline-block ml-1"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                      ></path>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div> */}
          <div className="space-y-8">
            <ul className="list-disc ml-5 space-y-2">
              <li>
                <Link
                  to="/alumni"
                  className="text-blue-600 hover:text-blue-700"
                >
                  EdUHK Alumni
                </Link>
              </li>
              <li>
                <Link
                  to="/teacher"
                  className="text-blue-600 hover:text-blue-700"
                >
                  School Teacher
                </Link>
              </li>
              <li>
                <Link
                  to="/individual"
                  className="text-blue-600 hover:text-blue-700"
                >
                  Individual
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Layout>
  );
}